/* ═══════════════════════════════════════════════════════════════════════════
   MATRIKAR — Page « Add to my order » — assets/mku-add-to-order.js
   2026-09-08

   Voir l'en-tête de sections/mku-add-to-order.liquid pour le pourquoi de la page.
   Ce fichier fait quatre choses :
     1. lit les paramètres du lien Klaviyo et personnalise l'affichage (commande, prénom, véhicule,
        gamme, couleur assortie) ;
     2. gère deux sélections exclusives, l'une dans le bloc personnalisation, l'autre dans les
        tapis de coffre ;
     3. tient la barre de récapitulatif à jour ;
     4. construit le panier et part au paiement.

   Aucune requête vers Shopify pour LIRE la commande : rien n'est lisible sans connexion client,
   et de toute façon Klaviyo possède déjà tout ce qu'on affiche.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var root = document.querySelector('[data-mku]');
  if (!root) return;

  var CFG = window.MKU || {};
  var FR = (CFG.locale || 'en').indexOf('fr') === 0;

  /* ── Devise ───────────────────────────────────────────────────────────────
     Les prix rendus par Liquid sont déjà dans la devise présentée. La remise, elle, est fixée en
     USD (30 $ Diamond et Hexa, 40 $ Ribbed) : on la convertit avec le taux que Shopify pose sur la
     page, puis on arrondit à l'unité, comme le fait le marché au moment du paiement. */
  var CUR = (window.Shopify && window.Shopify.currency) || {};
  var ACTIVE = CUR.active || 'USD';
  var RATE = parseFloat(CUR.rate || '1') || 1;

  function money(cents) {
    var value = cents / 100;
    try {
      /* Toujours en-US, même sur /fr : le format money du shop rend « $154 » dans les deux
         langues. Formater en fr-CA donnait « 111,76 $ » à côté d'un « $154 » barré. */
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: ACTIVE,
        /* Le site affiche « $154 » même en CAD (format money du shop). narrowSymbol garde la même
           lecture, sinon le prix barré rendu par Liquid et le prix promo rendu ici divergent. */
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: value % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      }).format(value);
    } catch (e) {
      return '$' + value.toFixed(0);
    }
  }

  /* Remise convertie, en cents de la devise présentée. Arrondie au CENT et non à l'unité : mesuré
     le 2026-09-08, Shopify applique 30 USD comme 42,24 CAD au paiement. Arrondir à 42 faisait
     annoncer 153 $ dans la barre pour 152,76 $ au paiement, et un écart, même d'un quart de dollar,
     se voit sur la page suivante. */
  function discountCents(code) {
    var usd = code === 'RIBBED79' ? 40 : 30;
    return Math.round(usd * RATE * 100);
  }

  /* ── Paramètres du lien ─────────────────────────────────────────────────── */
  var qs = new URLSearchParams(window.location.search);
  function param(key) {
    var v = qs.get(key);
    return v ? v.trim() : '';
  }

  var ORDER = param('o').replace(/^#/, '');
  var NAME = param('n');
  var VEHICLE = param('v');
  var SERIE = (param('s') || '').toLowerCase();
  var COLOR = (param('c') || '').toLowerCase();
  var HAS_PERSO = param('p') === '1';
  var BOUGHT = param('h');

  if (['diamond', 'hexa', 'ribbed', 'dual-layer'].indexOf(SERIE) === -1) SERIE = '';

  /* ── Bandeau ──────────────────────────────────────────────────────────────
     Quand le lien ne porte rien (page ouverte à la main, lien tronqué par un client mail), on
     garde le texte générique rendu par Liquid plutôt que d'afficher « Commande # ». */
  var badge = root.querySelector('[data-mku-badge]');
  var title = root.querySelector('[data-mku-title]');

  if (ORDER && badge) {
    badge.textContent = (FR ? 'Commande #' : 'Order #') + ORDER + (FR ? ' confirmée' : ' confirmed');
  }
  if (title) {
    if (NAME) {
      title.textContent = NAME + (FR
        ? ', vos tapis ne sont pas encore en production'
        : ', your mats are not in production yet');
    }
  }

  var facts = root.querySelector('[data-mku-facts]');
  var factVehicle = root.querySelector('[data-mku-fact-vehicle]');
  var factSeries = root.querySelector('[data-mku-fact-series]');
  var shownFact = false;

  if (VEHICLE && factVehicle) {
    factVehicle.querySelector('span').textContent = VEHICLE;
    factVehicle.hidden = false;
    shownFact = true;
  }
  if (SERIE && factSeries) {
    var serieName = SERIE === 'dual-layer' ? 'Dual-Layer' : SERIE.charAt(0).toUpperCase() + SERIE.slice(1);
    factSeries.querySelector('span').textContent = (FR ? 'Vos tapis : ' : 'Your mats: ') + serieName;
    factSeries.hidden = false;
    shownFact = true;
  }
  if (facts && shownFact) facts.hidden = false;

  /* ── Rappel de la commande ────────────────────────────────────────────────
     Une vignette du tapis qu'il vient d'acheter. On lit la fiche via /products/<handle>.js plutot
     que de faire voyager une URL d'image dans le lien : le lien reste court et l'image reste juste
     meme si la photo du produit change. Silencieux en cas d'echec, ce bloc n'est qu'un rappel. */
  var boughtWrap = root.querySelector('[data-mku-bought]');
  if (boughtWrap && BOUGHT) {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(base + 'products/' + encodeURIComponent(BOUGHT) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return;
        var img = boughtWrap.querySelector('[data-mku-bought-img]');
        var src = p.featured_image || (p.images && p.images[0]);
        if (!src) return;
        img.src = src.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2');
        img.alt = p.title || '';
        boughtWrap.querySelector('[data-mku-bought-title]').textContent = p.title || '';
        boughtWrap.hidden = false;
      })
      .catch(function () {});
  }

  /* ── Bloc personnalisation ────────────────────────────────────────────────
     Masqué quand la commande en porte déjà une : on ne revend pas ce qui est déjà acheté. */
  var persoBlock = root.querySelector('[data-mku-perso-block]');
  if (persoBlock && HAS_PERSO) persoBlock.hidden = true;

  /* Visuels de la gamme du client. Le Liquid a servi le jeu Diamond par défaut. */
  if (persoBlock && SERIE && CFG.files && CFG.files[SERIE]) {
    var set = CFG.files[SERIE];
    persoBlock.querySelectorAll('img[data-img-base]').forEach(function (img) {
      var url = set[img.getAttribute('data-img-base')];
      if (url) img.src = url;
    });
  }

  /* ── Tapis de coffre : la gamme du client passe devant ────────────────────
     Et dans cette gamme, la couleur assortie passe en tête avec son badge. Le reste du catalogue
     garde son ordre : le client qui veut autre chose le trouve juste en dessous. */
  var trunkBlock = root.querySelector('[data-mku-trunk-block]');
  if (trunkBlock && SERIE) {
    var mine = trunkBlock.querySelector('[data-mku-serie="' + (SERIE === 'dual-layer' ? 'diamond' : SERIE) + '"]');
    /* On insère APRÈS l'en-tête du bloc, jamais en tête du bloc : firstElementChild, c'est le
       titre « Add the matching trunk mat », et la grille passait au-dessus de lui. */
    var head = trunkBlock.querySelector('.mku-block__head');
    var anchor = head ? head.nextElementSibling : trunkBlock.firstElementChild;
    if (mine && anchor && anchor !== mine) {
      trunkBlock.insertBefore(mine, anchor);
    }
    if (mine && COLOR) {
      var match = mine.querySelector('[data-mku-trunk-card][data-color="' + CSS.escape(COLOR) + '"]');
      if (match) {
        var flag = match.querySelector('[data-mku-match]');
        if (flag) flag.hidden = false;
        feature(match);
      }
    }
  }

  /* ── Une seule carte devant, le reste replie ──────────────────────────────
     On DEPLACE la carte assortie (pas de clone : un clone aurait ses propres boutons et la
     selection se dedoublerait). Les enfants texte sont regroupes dans un .mku-card__body pour que
     la carte tienne a l'horizontale, image a gauche, decision a droite. */
  function feature(card) {
    var slot = root.querySelector('[data-mku-featured]');
    var moreWrap = root.querySelector('[data-mku-more-wrap]');
    if (!slot) return;

    var body = document.createElement('div');
    body.className = 'mku-card__body';
    var media = card.querySelector('.mku-card__media');
    var flag = card.querySelector('[data-mku-match]');

    /* Le badge part DANS la colonne de droite. Laisse en premier enfant de la carte, il devenait
       une troisieme colonne du flex et flottait a cote de l'image. */
    if (flag) body.appendChild(flag);
    Array.prototype.slice.call(card.children).forEach(function (child) {
      if (child === media || child === flag) return;
      body.appendChild(child);
    });
    card.appendChild(body);

    /* En vedette la carte est seule : « Diamond trunk mat, All Black » se lit mieux qu'un
       « All Black » sorti de nulle part, qui n'avait de sens qu'au milieu d'une grille. */
    var title = body.querySelector('.mku-card__title');
    var short = card.getAttribute('data-short');
    if (title && short) title.textContent = short;

    slot.appendChild(card);
    slot.hidden = false;

    /* Les grilles ne disparaissent pas, elles se replient : le client qui veut une autre couleur
       la trouve en un clic, celui qui voulait l'assortie n'a rien a trancher. */
    root.querySelectorAll('[data-mku-serie]').forEach(function (s) { s.hidden = true; });
    if (moreWrap) moreWrap.hidden = false;
  }

  var moreBtn = root.querySelector('[data-mku-more]');
  if (moreBtn) {
    moreBtn.addEventListener('click', function () {
      root.querySelectorAll('[data-mku-serie]').forEach(function (s) { s.hidden = false; });
      var wrap = root.querySelector('[data-mku-more-wrap]');
      if (wrap) wrap.hidden = true;
    });
  }

  /* Prix promo affiché sur chaque tapis de coffre. */
  root.querySelectorAll('[data-mku-trunk-card]').forEach(function (card) {
    var price = parseInt(card.getAttribute('data-price'), 10) || 0;
    var el = card.querySelector('[data-mku-promo-price]');
    if (el) el.textContent = money(Math.max(price - discountCents(card.getAttribute('data-promo')), 0));
  });

  /* ── Sélections ───────────────────────────────────────────────────────────
     Deux groupes indépendants, chacun exclusif. Un deuxième clic sur la carte déjà choisie la
     retire : le client doit pouvoir revenir en arrière sans recharger la page. */
  var picked = { perso: null, trunk: null };

  function toggle(card, group) {
    var siblings = root.querySelectorAll(group === 'perso' ? '[data-mku-perso-card]' : '[data-mku-trunk-card]');
    var already = picked[group] === card;
    siblings.forEach(function (c) { c.classList.remove('is-selected'); });
    picked[group] = already ? null : card;
    if (!already) card.classList.add('is-selected');
    renderBar();
  }

  root.querySelectorAll('[data-mku-perso-add]').forEach(function (btn) {
    btn.addEventListener('click', function () { toggle(btn.closest('[data-mku-perso-card]'), 'perso'); });
  });
  root.querySelectorAll('[data-mku-trunk-add]').forEach(function (btn) {
    btn.addEventListener('click', function () { toggle(btn.closest('[data-mku-trunk-card]'), 'trunk'); });
  });

  /* ── Champ véhicule ───────────────────────────────────────────────────────
     Un tapis de coffre est découpé sur mesure. Si le lien n'a pas porté le véhicule, on le demande,
     mais seulement quand un tapis de coffre est choisi : la personnalisation seule n'en a pas besoin. */
  var vehicleWrap = root.querySelector('[data-mku-vehicle-wrap]');
  var vehicleInput = root.querySelector('[data-mku-vehicle]');
  var vehicleErr = root.querySelector('[data-mku-vehicle-err]');

  function vehicleValue() {
    if (VEHICLE) return VEHICLE;
    return vehicleInput ? vehicleInput.value.trim() : '';
  }

  /* ── Barre de récapitulatif ───────────────────────────────────────────── */
  var bar = root.querySelector('[data-mku-bar]');
  var barTo = root.querySelector('[data-mku-bar-to]');
  var barItems = root.querySelector('[data-mku-bar-items]');
  var barTotal = root.querySelector('[data-mku-bar-total]');
  var submitBtn = root.querySelector('[data-mku-submit]');

  function renderBar() {
    var lines = [];
    var total = 0;

    if (picked.perso) {
      lines.push(picked.perso.getAttribute('data-label'));
      total += parseInt(picked.perso.getAttribute('data-price'), 10) || 0;
    }
    if (picked.trunk) {
      /* « Hexa trunk mat, Black & Red Stitching » plutôt que le titre catalogue complet, qui
         débordait la barre sur téléphone. */
      lines.push(picked.trunk.getAttribute('data-short') || picked.trunk.getAttribute('data-label'));
      total += Math.max(
        (parseInt(picked.trunk.getAttribute('data-price'), 10) || 0)
          - discountCents(picked.trunk.getAttribute('data-promo')),
        0
      );
    }

    if (!lines.length) {
      bar.hidden = true;
      if (vehicleWrap) vehicleWrap.hidden = true;
      return;
    }

    bar.hidden = false;
    barTo.textContent = ORDER
      ? (FR ? 'À joindre à la commande #' : 'Adding to order #') + ORDER
      : (FR ? 'Votre ajout' : 'Your add-on');
    barItems.textContent = lines.join(FR ? ' + ' : ' + ');
    barTotal.textContent = money(total);

    /* Le champ véhicule n'apparaît que s'il manque ET qu'un tapis de coffre est en jeu. */
    if (vehicleWrap) vehicleWrap.hidden = !(picked.trunk && !VEHICLE);
  }

  /* ── Envoi ────────────────────────────────────────────────────────────────
     On vide le panier avant d'ajouter : la barre annonce un contenu exact, un panier oublié la
     ferait mentir au paiement. Puis /discount/CODE?redirect=/checkout applique la remise du tapis
     de coffre. Sans tapis de coffre, il n'y a pas de code, on va droit au paiement. */
  function labelFor(propName) {
    return propName;
  }

  submitBtn.addEventListener('click', function () {
    if (submitBtn.disabled) return;

    var vehicle = vehicleValue();
    if (picked.trunk && !vehicle) {
      if (vehicleWrap) {
        vehicleWrap.hidden = false;
        vehicleWrap.classList.add('is-error');
      }
      if (vehicleErr) vehicleErr.hidden = false;
      if (vehicleInput) vehicleInput.focus();
      return;
    }
    if (vehicleWrap) vehicleWrap.classList.remove('is-error');
    if (vehicleErr) vehicleErr.hidden = true;

    var shipsWith = FR ? 'À joindre à la commande' : 'Ships with order';
    var vehicleProp = FR ? 'Véhicule' : 'Vehicle';
    var persoProp = FR ? 'Personnalisation' : 'Personalization';

    var items = [];

    if (picked.perso) {
      var pProps = {};
      pProps[persoProp] = picked.perso.getAttribute('data-label');
      if (ORDER) pProps[shipsWith] = '#' + ORDER;
      if (vehicle) pProps[vehicleProp] = vehicle;
      pProps._mk_perso = picked.perso.getAttribute('data-code');
      pProps._mk_upsell_order = ORDER || '';
      items.push({ id: parseInt(picked.perso.getAttribute('data-variant'), 10), quantity: 1, properties: pProps });
    }

    if (picked.trunk) {
      var tProps = {};
      if (ORDER) tProps[shipsWith] = '#' + ORDER;
      if (vehicle) tProps[vehicleProp] = vehicle;
      tProps._mk_upsell_order = ORDER || '';
      items.push({ id: parseInt(picked.trunk.getAttribute('data-variant'), 10), quantity: 1, properties: tProps });
    }

    if (!items.length) return;

    submitBtn.disabled = true;
    submitBtn.querySelector('.spin').hidden = false;

    var note = ORDER
      ? (FR
          ? 'Ajout à la commande #' + ORDER + ' — à expédier dans le même colis'
          : 'Add-on to order #' + ORDER + ' — ship in the same box')
      : '';

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/clear.js' : '/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    })
      .then(function () {
        return fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        if (!note && !ORDER) return null;
        return fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: note, attributes: { 'Add-on to order': ORDER ? '#' + ORDER : '' } })
        });
      })
      .then(function () {
        var code = picked.trunk ? picked.trunk.getAttribute('data-promo') : '';
        window.location.href = code
          ? '/discount/' + encodeURIComponent(code) + '?redirect=/checkout'
          : '/checkout';
      })
      .catch(function () {
        submitBtn.disabled = false;
        submitBtn.querySelector('.spin').hidden = true;
        alert(FR
          ? "L'ajout n'a pas fonctionné. Réessayez, ou répondez au courriel et on s'en occupe"
          : "That did not go through. Try again, or reply to the email and we will handle it");
      });
  });

  /* ── Lightbox ─────────────────────────────────────────────────────────── */
  var lb = root.querySelector('[data-mku-lightbox]');
  var lbImg = root.querySelector('[data-mku-lightbox-img]');
  var lbCap = root.querySelector('[data-mku-lightbox-caption]');

  function openLightbox(trigger) {
    var img = trigger.querySelector('img');
    if (!img) return;
    lbImg.src = img.currentSrc || img.src;
    lbImg.alt = trigger.getAttribute('data-label') || '';
    lbCap.textContent = trigger.getAttribute('data-caption') || '';
    var lbSet = root.querySelector('[data-mku-lightbox-set]');
    if (lbSet) lbSet.textContent = trigger.getAttribute('data-price-note') || '';
    lb.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    lb.hidden = true;
    document.body.style.overflow = '';
  }

  root.querySelectorAll('[data-mku-zoom]').forEach(function (el) {
    el.addEventListener('click', function () { openLightbox(el); });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(el); }
    });
  });
  root.querySelectorAll('[data-mku-lightbox-close]').forEach(function (el) {
    el.addEventListener('click', closeLightbox);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !lb.hidden) closeLightbox();
  });

  renderBar();
})();
